export interface Entity {
   id: string;
   entityType: string;
   lastFirstName: string;
   fullName: string;
   dateOfBirth?: Date;
   age?: number;
   fullAddress: string;
   isFlagged?: boolean
}